/**
 * Shared form input style — use across all Input/Update pages.
 */
export const inputStyle = {
    // Design tokens (styles/tokens.css): 38px desktop / 42px phone, 16px text on phones.
    minHeight: "var(--control-h)",
    padding: "var(--control-pad)",
    borderRadius: "var(--radius-control)",
    border: "var(--control-border) solid var(--border)",
    fontSize: "var(--fs-control)",
    color: "var(--ink-body)",
    background: "var(--paper)",
    outline: "none",
    transition: "border-color 0.15s",
    width: "100%",
};


// utils/fieldEvents.js

/**
 * Input types that support text selection
 */
const SELECTABLE_INPUT_TYPES = [
    "text",
    "search",
    "password",
    "tel",
    "url",
    "email",
    "number",
];

/**
 * Check whether the element supports select()
 */
const isSelectableElement = (el) => {
    if (!el) return false;

    // <input>
    if (
        el instanceof HTMLInputElement &&
        SELECTABLE_INPUT_TYPES.includes(el.type) &&
        typeof el.select === "function"
    ) {
        return true;
    }

    // <textarea>
    if (
        el instanceof HTMLTextAreaElement &&
        typeof el.select === "function"
    ) {
        return true;
    }

    return false;
};

/**
 * Unified field event handlers for form inputs
 */
export const fieldEvents = {
    onFocus: (e) => {
        const el = e.target;

        // visual feedback
        el.style.borderColor = "#c84535";

        // safely select text if supported
        if (isSelectableElement(el)) {
            // wait for browser + React focus to settle
            requestAnimationFrame(() => {
                el.select();
            });
        }
    },

    onBlur: (e) => {
        e.target.style.borderColor = "#e2dbd9";
    },

    onWheel: (e) => {
        const el = e.target;

        // prevent accidental scroll change on number inputs
        if (el instanceof HTMLInputElement && el.type === "number") {
            el.blur();
        }
    },
};